module.exports = __webpack_public_path__ + "img/KR.7d474749.png";